import { Injectable } from '@angular/core';
import { SecureHttp } from '../helpers/securehttp';
import { map, Observable, tap } from 'rxjs';
import { QuestionnaireQuestionModel } from '../models/questionnaire-question.model';
import { QuestionnaireTemplateModel } from '../models/questionnaire-template.model';
import { environment } from '../../environments/environment';
import { TemplateDetailsModel } from '../models/template-details.model';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {
  questionnaireTemplate: QuestionnaireTemplateModel | undefined;

  constructor(private http: SecureHttp) { }

  get currentTemplateDetails(): TemplateDetailsModel[] {
    return JSON.parse(localStorage.getItem('questionnaireTemplate') as string) as TemplateDetailsModel[];
  }

  getQuestionnaireQuestions(): Observable<QuestionnaireQuestionModel[]> {
    let url = `${environment.apiUrl}api/questions`
    return this.http
      .get(url).pipe(
        map((response) => response as QuestionnaireQuestionModel[]))
  }

  getQuestionnaireTemplates(): Observable<QuestionnaireTemplateModel[]> {
    let url = `${environment.apiUrl}api/questionnaire/templates`
    return this.http
      .get(url).pipe(
        map((response) => response as QuestionnaireTemplateModel[]))
  }

  getQuestionnaireQuestion(
    questionNum: string
  ): Observable<QuestionnaireQuestionModel> {
    let url = `${environment.apiUrl}api/questions/${questionNum}`

    return this.http
      .get(url).pipe(
        map((response) => response as QuestionnaireQuestionModel))
  }

  getQuestionnaireTemplate(
    templateID: number
  ): Observable<QuestionnaireTemplateModel> {
    let url = `${environment.apiUrl}api/questionnaire/templates/${templateID}`
    return this.http
      .get(url).pipe(
        tap((response) => localStorage.setItem('questionnaireTemplate', (response as QuestionnaireTemplateModel).TemplateDetails.toString())),
        map((response) => response as QuestionnaireTemplateModel))
  }

  createQuestionnaireQuestion(
    question: QuestionnaireQuestionModel
  ): Observable<QuestionnaireQuestionModel> {
    let url = `${environment.apiUrl}api/questions`
    return this.http
      .post(url, question).pipe(
        map((response) => response as QuestionnaireQuestionModel))
  }

  updateQuestionnaireQuestion(
    question: QuestionnaireQuestionModel
  ): Observable<QuestionnaireQuestionModel> {
    let url = `${environment.apiUrl}api/questions`
    return this.http
      .put(url, question).pipe(
        map((response) => response as QuestionnaireQuestionModel))
  }

  createQuestionnaireTemplate(
    template: QuestionnaireTemplateModel
  ): Observable<QuestionnaireTemplateModel> {
    let url = `${environment.apiUrl}api/questionnaire/templates`
    return this.http
      .post(url, template).pipe(
        map((response) => response as QuestionnaireTemplateModel))
  }

  updateQuestionnaireTemplate(
    template: QuestionnaireTemplateModel
  ): Observable<QuestionnaireTemplateModel> {
    let url = `${environment.apiUrl}api/questionnaire/templates`
    return this.http
      .put(url, template).pipe(
        map((response) => response as QuestionnaireTemplateModel))
  }
}
